export enum InitiatedGridViewId {
  COLLATERAL_COUPON_MATURE_DATE = 'COLLATERAL_COUPON_MATURE_DATE',
  COLLATERAL_CUSIP = 'COLLATERAL_CUSIP',
  COLLATERAL_NAME = 'COLLATERAL_NAME',
  COLLATERAL_ISIN_OR_BUI = 'COLLATERAL_ISIN_OR_BUI',
  COLLATERAL_ISSUE = 'COLLATERAL_ISSUE',
  COLLATERAL_PINNED = 'COLLATERAL_PINNED',
  NEGOTIATION_DIRECTION = 'NEGOTIATION_DIRECTION',
  NEGOTIATION_STATUS = 'STATUS',
  TARGET = 'TARGET',
  INFLIGHT = 'INFLIGHT',
  COUNTERPARTY_ACTIONS = 'COUNTERPARTY_ACTIONS',
  COUNTERPARTY_NOTIONAL = 'COUNTERPARTY_NOTIONAL',
  COUNTERPARTY_RATE = 'COUNTERPARTY_RATE',
  COUNTERPARTY_HAIRCUT = 'COUNTERPARTY_HAIRCUT'
}
